<template>
  <ul class="message-feed">
    <template v-if="channexFeed && channexFeed.length">
      <li :class="'feed-item no-image clickable'" v-for="item in channexFeed" v-on:click="displayMessage(item)">
        <span class="feed-content">
          <span class="feed-date" v-if="item && item.inserted_at">{{ DateTime.fromISO(item.inserted_at).toFormat(dateFormat + ' ' + timeFormat) }} <strong>{{ item.sender_name }}</strong> <span class="pull-right label label-primary label-xs">{{ _('Order') }} {{ item.order_id }}</span></span>
          <span class="feed-text" v-if="item && item.message" style="white-space: pre-line">{{ item.message }}</span>
        </span>
      </li>
    </template>
    <template v-else>
      <li> 
        <div class="empty-feed">{{ _('Latest messages from external sales channels will be listed here.') }}</div>
      </li>
    </template>
  </ul>
</template>
<script>
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'

export default {
  data () {
    return {
      notificationsReadAt: 0,
      channexFeed: [],
      DateTime: DateTime
    }
  },
  props: ['feed'],
  watch: {
    feed: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.channexFeed = newValue.slice(0,10)
        this.updateUnreadChannexPostCount()
      }
    }
  },
  computed: {
    ...mapGetters(['shopId', 'dateFormat', 'timeFormat']),
    unreadChannexPostCount: {
      /* Save & Load this setting from some user-spesific backend mysteryplace */
      get() {
        return this.$store.state.unreadChannexPostCount
      },
      set(newValue) {
        // return this.$store.dispatch('setUnreadChannexPostCount', newValue)
      }
    }
  },
  methods: {
    displayMessage (message) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'OrderDetails',
        title: this._('Order') + ' ' + message.order_id + (message.sender_name && message.sender_name !== message.sender ? ': ' + message.sender_name : ''),
        width: 6,
        data: {
          orderId: message.order_id,
          activeTab: 'messages'
        }
      })
    },
    updateUnreadChannexPostCount() {
      let $this = this
      if(!(this.channexFeed && this.channexFeed.length)) {
        return 0
      }
      // The frontend also supports real numbers - up to 99 - but as we honestly don't have a way to tell if user has read anything, it is better
      // to just use ' ' that creates a simple notification dot without any numbers
      this.unreadChannexPostCount = (this.channexFeed.filter(item => item.timestamp > $this.notificationsReadAt).length > 0 ? ' ' : 0)
    },
    addToFeed(data) {
      if(!data.timestamp) {
        data.timestamp = new Date().getTime()
      }
      this.channexFeed.unshift(data)
      this.channexFeed = this.channexFeed.slice(0,10)
      this.updateUnreadChannexPostCount()
    },
    rightNaviToggled() {
      this.notificationsReadAt = new Date().getTime()
      this.updateUnreadChannexPostCount()
    }
  },
  mounted () {
    let $this = this 
    this.updateUnreadChannexPostCount()
    this.EventBus.$on('rightNaviToggled', () => {
      $this.rightNaviToggled()
    })
    this.EventBus.$on('channexMessage', (data) => {
      $this.addToFeed(data)
    })
  }
}
</script>